import { resolveQName } from "@qdabra/forms-shared/xmlHelpers";
import { attributeValue } from "func-xml";
import { applySpec, init, isEmpty, last, prop } from "ramda";
import { VIEW_EVENT_MULTISELECT } from "../viewActionHandler/viewActionHandler.constants";
import viewAction from "../viewWatcher/viewAction";
import { ATTR_ON_VALUE, ATTR_XD_REF } from "./view.attribute.names";
import { getNodeId } from "./viewNodeAccessors";

const checkEventProps = applySpec({
    nodeId: getNodeId,
    select: prop('checked'),
    value: attributeValue(ATTR_ON_VALUE),
});

const controlEventProps = applySpec({
    controlNodeId: getNodeId,
    ref: attributeValue(ATTR_XD_REF),
});

export const getMultiSelectChangeAction = (checkEl) => {
    const multiSelectControl = checkEl.closest('.xdMultiSelectList');

    if (!multiSelectControl) {
        console.error('Could not find parent multiselect control for checkbox', checkEl);

        return;
    }

    return viewAction(
        VIEW_EVENT_MULTISELECT,
        {
            ...checkEventProps(checkEl),
            ...controlEventProps(multiSelectControl),
        },
    );
};

export const parseMultiSelectRef = (path, namespaces) => {
    const segments = path.split('/');
    const nodeQName = last(segments);

    if (isEmpty(segments)) {
        throw new Error('Failed to select multiselect item. Could not parse node path.');
    }

    return {
        containerPath: init(segments).join('/') || '.',
        nodeQName,
        nodeName: resolveQName(namespaces, nodeQName),
    };
};

export const addMultiSelectValue = async (startNode, { containerPath, nodeQName, nodeName }, value) => {
    const parent = startNode.selectSingle(containerPath);
    const { namespaceURI } = nodeName;

    if (!parent) {
        throw new Error('Could not find parent node for multiselect box');
    }

    let newItem = namespaceURI
        ? startNode.createElementNS(namespaceURI, nodeQName)
        : startNode.createElement(nodeQName);

    newItem.textContent = value;

    await parent.appendChildAsync(newItem);
};

export const removeMultiSelectValue = (startNode, path, value) => {
    const matchingNodes = startNode
        .selectNodes(path)
        .filter((n) => n.value() === value);

    if (isEmpty(matchingNodes)) {
        throw new Error("Could not locate items to deselect in data source.");
    }

    for (const node of matchingNodes) {
        node.deleteSelf();
    }
};